import React, { useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import Input from "components/Input";
import Btn from "components/Btn";
import * as UIcons from '@iconscout/react-unicons';
import { useLocation } from 'react-router-dom'

export default function EditTTrailer({ trailer = {}, onSave = () => null, onCancel = () => null }) {
  const { state } = useLocation();
  trailer = state?.trailer || trailer || {};
  const methods = useForm({
    defaultValues: {
      title: trailer?.name || trailer?.title || "This is the title of the movie",
      description: trailer?.description || `"Avengers: Endgame" is the epic conclusion to the Marvel Cinematic Universe's Infinity Saga. Following the devastating events of "Avengers: Infinity War," where the villain Thanos wiped out half of all life in the universe with a snap of his fingers, the remaining Avengers must grapple with their loss and find a way to reverse the catastrophic effects of Thanos’s actions.\n\nFollowing the devastating events of "Avengers: Infinity War," where the villain Thanos wiped out half of all life in the universe with a snap of his fingers, the remaining Avengers`,
      file: null,
    },
    mode: "onChange",
  });

  const { handleSubmit, watch, setValue } = methods;
  const f = watch("file");
  const fileName = useMemo(() => {
    if (!f) return "Uploadedfilename.mov";
    if (typeof f === "string") return f;
    if (f instanceof File) return f.name;
    return "Uploadedfilename.mov";
  }, [f]);

  const [uploaded, setUploaded] = useState(true);

  const onSubmit = (values) => {
    onSave({
      title: values.title,
      description: values.description,
      file: f,
    });
  };

  const handleFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setValue("file", file);
      setUploaded(true);
    }
  };

  return (
    <FormProvider {...methods}>
      <div className="min-h-screen w-full flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <button onClick={onCancel} className="w-8 h-8 flex items-center justify-center rounded-md bg-gray-100">
            <UIcons.UilMultiply className="text-black" />
          </button>
          <p className="text-black font-bold">Edit trailer detail</p>
          <div className="flex items-center gap-2">
            <Btn content={"Cancel"} variant="outline" click={onCancel} className="px-4" />
            <Btn content={"Save"} click={handleSubmit(onSubmit)} className="px-4" />
          </div>
        </div>

        <div className="w-full flex justify-center px-6 py-10">
          <form className="w-full max-w-3xl">
            <div className="mb-6">
              <Input name="title" label="Movie title" placeholder="Enter movie title" />
            </div>

            <div className="mb-6">
              <Input name="description" type="textarea" rows={8} label="Movie description" placeholder="Enter movie description" />
            </div>

            <div className="mb-6">
              <p className="text-sm font-semibold text-gray-700 mb-2">Media file</p>
              <div className="border border-dashed rounded-xl p-4">
                <div className="flex items-center justify-between bg-gray-50 rounded-md px-4 py-3">
                  <div className="flex items-center gap-3">
                    <span className="w-5 h-5 rounded-full bg-green-500 inline-block" />
                    <div>
                      <p className="text-gray-900">{fileName}</p>
                      {uploaded && <p className="text-xs text-gray-500">Uploaded</p>}
                    </div>
                  </div>
                  <label htmlFor="trailer-file" className="cursor-pointer">
                    <UIcons.UilTrashAlt className="text-black" />
                  </label>
                  <input id="trailer-file" type="file" className="hidden" onChange={handleFileSelect} accept="video/*" />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </FormProvider>
  );
}
